<span class="ui-tag">{{ label() }}</span>
